import React, { useEffect, useState } from "react";
import { useQueryParam } from "use-query-params";

import DesktopCustomSelect from "@src/componentsNew/Select/DesktopCustomSelect";

import { ProductOrderField, OrderDirection, ProductOrder } from "__generated__/globalTypes";
import { productsVariables } from "@components/ProductPage/ProductList/__generated__/products";

import { PRODUCTS_SORTING_FILTER_OPTIONS } from "@src/utils/constants";

const SortingParam = {
  encode: (productOrder: ProductOrder) => {
    const direction = productOrder.direction;
    const directionCharacter = direction === OrderDirection.ASC ? "" : "-";
    const field = productOrder.field.toLowerCase();
    return `${directionCharacter}${field}`;
  },
  decode: (value: string) => {
    if (!!value) {
      value = value.toUpperCase();
      let field = null;
      let direction = null;
      if (value[0] === "-") {
        direction = OrderDirection.DESC;
        const strField: string = value.slice(1);
        field = (ProductOrderField as any)[strField];
      } else {
        direction = OrderDirection.ASC;
        field = (ProductOrderField as any)[value];
      }
      return {
        field: field as ProductOrderField,
        direction: direction as OrderDirection,
      } as ProductOrder;
    } else {
      return {
        field: ProductOrderField.POPULARITY,
        direction: OrderDirection.DESC,
      } as ProductOrder;
    }
  },
};

interface IProps {
  variables: productsVariables;
  setVariables: any;
}

const DesktopProductListSortingFilter = ({ variables, setVariables }: IProps) => {
  const [selectedOption, setSelectedOption] = useState(PRODUCTS_SORTING_FILTER_OPTIONS.find(option =>
    option.value.field === variables.sortBy.field &&
    option.value.direction === variables.sortBy.direction
  ));

  const [sortBy, setSortBy] = useQueryParam("sort_by", SortingParam);

  useEffect(() => {
    const newOption = PRODUCTS_SORTING_FILTER_OPTIONS.find(option =>
      option.value.field === sortBy.field && option.value.direction === sortBy.direction
    );

    setSelectedOption(newOption);
    setVariables((prev) => ({
      ...prev,
      sortBy
    }));
  }, [sortBy]);

  const onChangeOption = (value) => {
    const newOption = PRODUCTS_SORTING_FILTER_OPTIONS.find(option => option.label === value.label);

    setSortBy(newOption.value);
  };

  return (
    <DesktopCustomSelect
      label="Sort by"
      options={PRODUCTS_SORTING_FILTER_OPTIONS}
      value={selectedOption ? selectedOption.label : ''}
      onChange={onChangeOption}
    />
  );
};

export default DesktopProductListSortingFilter;
